import { ReactNode, SyntheticEvent } from 'react';
import { Flex, FlexProps, Text } from '@chakra-ui/react';

import { Checkbox } from '../../lib/chakraUi/components/Checkbox';
import {
  FormFieldControlledComponent,
  FormFieldControlledComponentProps,
} from '../../types/fields';

// @TODO Rename to "Acknowledgement"?

type ConsentProps = FlexProps & {
  content: ReactNode;
};

export const Consent: FormFieldControlledComponent<boolean, ConsentProps> = ({
  _ref,
  content,
  invalid,
  name,
  onChange: _onChange,
  value,
  ...props
}: FormFieldControlledComponentProps<boolean, ConsentProps>) => {
  // The acknowledgement text sits beside the checkbox rather than inside it,
  // so the input is pointed at that text for its accessible name.
  const contentId = `${name}-content`;
  const checkboxProps = {
    inputProps: { 'aria-labelledby': contentId },
    invalid,
    name,
    ref: _ref,
  };

  const onChange = (event: SyntheticEvent): void => {
    event.preventDefault();
    _onChange(!value);
  };

  return (
    <Flex
      alignItems="center"
      asChild
      bg="secondary.700"
      borderRadius="sm"
      p={5}
      shadow="md"
      {...props}
    >
      <label htmlFor={name}>
        <Checkbox
          bg="white"
          borderColor="secondary.200"
          borderRadius="sm"
          checked={value}
          colorPalette="primary"
          id={name}
          onChange={onChange}
          size="lg"
          {...checkboxProps}
        />

        <Text id={contentId} ml={5} textAlign="left">
          {content}
        </Text>
      </label>
    </Flex>
  );
};

Consent.controlled = true;
Consent.displayName = 'Consent';
